import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.details-wrapper {
    display: block;
    margin: auto;
    padding: calc(8px * 2);
    text-align: left;
    font-weight: bold;
    background-color: #ffffff;
    border: 1px solid #f0f3f5;
    border-radius: 4px;
    transition: box-shadow, 300ms;
    transition-timing-function: ease-out;
}
.details-wrapper:hover {
  box-shadow: 0px 8px 8px rgba(45, 57, 64, 0.06);
  z-index: 1;
    position: relative;
}
.details-wrapper:focus {
    border: 1px solid #006894;
}
.details-wrapper:active {
    border: 1px solid #006894;
}
a.details-link {
    display: block;
    text-decoration: none;
}
.details-title {
    color: #086ea1;
    text-decoration: none;
    display: block;
    font-size: 16px;
    line-height: 24px;
}
.description {
    color: #6b7880;
    font-weight: normal;
    text-decoration: none;
    line-height: 22px;
    font-size: 14px;
    letter-spacing: 0;
    display: block;
}
.sub-description {
    color: #6b7880;
    font-weight: normal;
    text-decoration: none;
    letter-spacing: 0;
    display: block;
}
.split-heading {
    line-height: 24px;
}
.title-padding {
    padding: calc(8px * 3);
}
@media (max-width: 720px) {
    .details-wrapper {
        min-width: auto;
    }
}
@media screen and (prefers-reduced-motion: reduce) {
    .details-wrapper {
        transition: none;
    }
}
`;

export default styles;